
import { useParams } from "react-router-dom";
import { useState } from "react";
// import { useQuery } from "@tanstack/react-query"; // Temporarily commented out
import Header from "@/components/Header";
import { parts } from "@/data/parts";
// import { fetchPartById } from "@/services/partService"; // Temporarily commented out
// import { checkSupabaseConnection } from "@/lib/supabase"; // Temporarily commented out
import PartDetailsHeader from "@/components/PartDetailsHeader";
import PartDetailsContent from "@/components/PartDetailsContent";
import PartDetailsSidebar from "@/components/PartDetailsSidebar";

const PartDetails = () => {
  const { id } = useParams();
  const [isSupabaseConnected, setIsSupabaseConnected] = useState<boolean | null>(false); // Force to false
  const parsedId = Number(id);
  
  // Commented out Supabase connection check
  /*
  useEffect(() => {
    // Check Supabase connection on component mount
    const checkConnection = async () => {
      const isConnected = await checkSupabaseConnection();
      setIsSupabaseConnected(isConnected);
    };
    checkConnection();
  }, []);
  */

  // Commented out Supabase query
  /*
  // Fetch part data from Supabase if connected
  const { data: supabasePart, isLoading } = useQuery({
    queryKey: ['part', parsedId],
    queryFn: () => fetchPartById(parsedId),
    enabled: isSupabaseConnected === true && !isNaN(parsedId),
  });
  */

  // Mock loading state
  const isLoading = false;
  
  // Always use static data
  const part = parts.find(p => p.id === parsedId);
  
  // Handle case where part is not found
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <div className="container py-16 text-center pt-[64px]">
          <p>Loading part details...</p>
        </div>
      </div>
    );
  }

  if (!part) {
    return (
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        <div className="container py-16 text-center pt-[64px]">
          <h1 className="text-2xl font-bold mb-4">Part Not Found</h1>
          <p className="mb-6">The part you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <div className="container py-8 pt-[64px]">
        <PartDetailsHeader isSupabaseConnected={isSupabaseConnected} />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Description column - takes up 2/3 of the width on desktop */}
          <div className="md:col-span-2">
            <PartDetailsContent part={part} />
          </div>
          
          {/* Sidebar column - takes up 1/3 of the width on desktop */}
          <div className="md:col-span-1">
            <PartDetailsSidebar part={part} />
          </div>
        </div>
      </div>
      
      <footer className="bg-card border-t border-border py-6 mt-auto">
        <div className="container">
          <p className="text-sm text-center text-muted-foreground">
            3DP Hub | The ultimate directory for 3D printer parts and upgrades
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PartDetails;
